import type { FinanceCalculatorEnvironment } from 'src/app/shared/financing/finance-calculator/finance-calculator-environment.enum';

export enum DoorwayElement {
  BackendUrl = 'backendUrl',
  CarlUrl = 'carlUrl',
  CarlLabel = 'carlLabel',
  FormattingTag = 'formattingTag',
  ConfigurationDate = 'configurationDate',
  SalesLevelType = 'salesLevelType',
  FcisEnvironment = 'fcisEnvironment'
}

export interface DoorwayConfiguration {
  disabled: DoorwayElement[];
}

export interface Settings {
  doorwayConfiguration?: DoorwayConfiguration;
  apis: {
    backend: {
      baseUrl?: string;
      // all optional because this gets merged with default settings
      mailEndpoint?: string;
      onlineCodesEndpoint?: string;
      timeout?: {
        // ℹ️ timeout is currently only adjustable for motorization request
        // ℹ️ Note: default timeout (given by the infrastructure [browser and server]) is (probably) 30 seconds - we can limit but not extend the timeout without hacks
        motorization?: number;
      };
      retryCount?: number;
      formattingTag?: string;
    };

    carl: { baseUrl?: string; label?: string };

    // used for validating testdrive links
    deeplinks: {
      baseUrl?: string;
    };

    ocapi: {
      baseUrl?: string;
      apiKey?: string;
    };

    // onemirror distribution service
    omds: {
      baseUrl?: string;
      accessToken?: string;
      relayService?: string;
    };
  };
  abTesting?: {
    // AB testing is generally just available in integrated mode, not standalone mode. In order to test
    // even on localhost, AB testing can also be activated for standalone mode (not default)
    activeInStandaloneMode: boolean;
  };
  // Environment-specific message for doorway and header. Used by BE-deployed environments
  envSpecificMessage?: string;
  financialCalculatorEnvironment: FinanceCalculatorEnvironment;
}
